module.exports = __webpack_public_path__ + "static/media/ppls.1b7ceb2c.rar";